import styled from "@emotion/styled";
import {LiveMapControls, type LiveMapDisplayOptions, type LiveMapEntity} from "@ots-frontend/ots-ui-tw";

const TopPanelContainer = styled.div`
  pointer-events: auto;
  border: 0;
  padding: 10px;
  position: absolute;
  top: 0;
  left: 50%;
  min-width: 100px;
  transform: translateX(-50%);
`;

const isLiveMapEntity = (entity: string): entity is LiveMapEntity =>
  entity === "PERSON" || entity === "TRAILER" || entity === "VEHICLE";

export type TopPanelProps = {
  entity?: string,
  onEntityChange: (entity: string) => void
  display: LiveMapDisplayOptions
  onDisplayChange: (display: LiveMapDisplayOptions) => void
  displayDefaults?: LiveMapDisplayOptions
  showOpsMode?: boolean
  opsMode?: boolean
  onOpsModeChange?: (opsMode: boolean) => void
  onFitFleet?: () => void
  onFitSites?: () => void
}

export const TopPanel = (props: TopPanelProps) => {
  const {
    entity = 'TRAILER',
    onEntityChange,
    display,
    onDisplayChange,
    displayDefaults,
    showOpsMode = false,
    opsMode = false,
    onOpsModeChange,
    onFitFleet,
    onFitSites,
  } = props

  return (
    <TopPanelContainer>
      <LiveMapControls
        entity={isLiveMapEntity(entity) ? entity : 'TRAILER'}
        onEntityChange={onEntityChange}
        display={display}
        onDisplayChange={onDisplayChange}
        defaults={displayDefaults}
        showOpsMode={showOpsMode}
        opsMode={opsMode}
        onOpsModeChange={onOpsModeChange}
        onFitFleet={onFitFleet}
        onFitSites={onFitSites}
      />
    </TopPanelContainer>
  )
}
